var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRelateInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.976 14.496c.458.455.268.182.573-.121l2.815-2.813c.305-.304 1.165-.678.707-1.132-.458-.455-1.075-.577-1.38-.275l-3.148 3.132c-.305.303-.024.755.433 1.21zm-2.298 3.77l-1.99-1.988 4.235-4.233a3.127 3.127 0 00-3.101.765l-2.21 2.194c-1.22 1.211-.438 2.4.782 3.611 1.22 1.213 2.417 1.988 3.638.776l2.209-2.193a3.08 3.08 0 00.73-3.22l-4.293 4.289zM18.592 6.4c-1.241-1.233-2.473-2.01-3.714-.776L12.63 7.854a3.13 3.13 0 00-.753 3.236l4.42-4.416 1.991 1.989-4.409 4.407a3.183 3.183 0 003.247-.752l2.247-2.232c1.241-1.232.46-2.455-.781-3.687z",
    fill: "#29C1B9"
  })));
}
export default SvgRelateInfo;